import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'app-normas',
  template: '',
  standalone: false
})
export class NormasComponent implements OnInit {
  url: string = ''

  constructor() {
    this.url = 'https://www2.unesp.br/portal#!/propg/paades/'
  }

  ngOnInit(): void {
    window.open(this.url, '_blank')
  }
}
